module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10660/images/google-contacts-sync.svg"